module.exports = __webpack_public_path__ + "static/media/main_image_3.0eab44cd.jpg";